import BaseService from './base-service.js'

function escapeKey(key) {
    return encodeURIComponent(key);
}

export default {
    // Return resource list
    getResources({ projectUuid, params }) {
        const resource = `projects/${projectUuid}/resources`
        return BaseService.get(`${resource}`, {
            params,
        }).then(resp => resp.data)
    },

    // Return localization list
    getLocalizations({ userUuid, langCode,  params }) {
        const url = `users/${userUuid}/localizations/${langCode}`
        return BaseService.get(`${url}`, {
            params,
        }).then(resp => resp.data)
    },

    // Return localization list by key
    getLocalizationsByKey({ projectUuid, key, data }) {
        const url = `projects/${projectUuid}/resources/${escapeKey(key)}/localizations/_search`
        return BaseService.post(`${url}`, data).then(resp => resp.data)
    },

    // Return resource notes
    getNotes({ projectUuid, key, params }) {
        const url = `projects/${projectUuid}/resources/${escapeKey(key)}/notes`
        return BaseService.get(`${url}`, {
            params,
        }).then(resp => resp.data)
    },

    // Add resource note
    addNote({ projectUuid, key, data }) {
        const url = `projects/${projectUuid}/resources/${escapeKey(key)}/notes`
        return BaseService.post(`${url}`, data).then(resp => resp.data)
    },

    // Return resource list
    getResourceKey({ projectUuid, key, params }) {
        const resource = `projects/${projectUuid}/resources/${escapeKey(key)}`
        return BaseService.get(`${resource}`, {
            params,
        }).then(resp => resp.data)
    },

    // Update resource primary info
    updateResourceInfo({ projectUuid, key, data }) {
        const resource = `projects/${projectUuid}/resources/${escapeKey(key)}`
        return BaseService.put(`${resource}`, data).then(resp => resp.data)
    },

    // Update single resource
    updateResourceSingle({ projectUuid, langCode, key, data }) {
        const resource = `projects/${projectUuid}/${langCode}/resources/${escapeKey(key)}`
        return BaseService.put(`${resource}`, data).then(resp => resp.data)
    },
   
    // Update localization
    updateLocalization({ projectUuid, langCode, key, data }) {
        const resource = `projects/${projectUuid}/resources/${escapeKey(key)}/localizations/${langCode}`
        return BaseService.put(`${resource}`, data).then(resp => resp.data)
    },


    // Return resource list
    deleteResourceKey({ projectUuid, key }) {
        const resource = `projects/${projectUuid}/resources/${escapeKey(key)}`
        return BaseService.delete(`${resource}`).then(resp => resp.data)
    },

    // Return tag list
    getResourcesTags({ projectUuid, params }) {
        const resource = `projects/${projectUuid}/resource-tags`
        return BaseService.get(`${resource}`, {
            params,
        }).then(resp => resp.data)
    },

    // Add resources
    addResources({ projectUuid, langCode, data }) {
        const resource = `projects/${projectUuid}/${langCode}/resources`
        return BaseService.post(`${resource}`, data).then(resp => resp.data)
    },

    // Add resource lock
    addResourceLock({ projectUuid, langCode, resourceKey }) {
        const resource = `projects/${projectUuid}/resources/${escapeKey(resourceKey)}/locks/${langCode}`
        return BaseService.post(`${resource}`).then(resp => resp.data)
    },

    // Del resource lock
    delResourceLock({ projectUuid, langCode, resourceKey }) {
        const resource = `projects/${projectUuid}/resources/${escapeKey(resourceKey)}/locks/${langCode}`
        return BaseService.delete(`${resource}`)
    },

    // Translation Google lock
    postTranslationGoogle({ projectUuid, resourceKey }) {
        const resource = `projects/${projectUuid}/resources/${resourceKey}/_auto-translate`
        return BaseService.post(`${resource}`).then(resp => resp.data)
    },
}
